// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"100":"forgot-password","710":"buyer-registration","966":"login"}[chunkId] || chunkId) + "." + {"100":"6cfaaa07","268":"948f61ac","710":"5e7eadfc","822":"ea6e744b","966":"31333bdd"}[chunkId] + ".js";
};